// extracted by mini-css-extract-plugin
export var actionButton = "_kt-t";
export var buttonContainer = "_kt-0";
export var buttonContainer2 = "_kt-1";
export var buttonSection = "_kt-2";
export var details = "_kt-3";
export var dropdownItem = "_kt-5";
export var dropdownItemsContainer = "_kt-4";
export var fileInput = "_kt-r";
export var headerButton = "_kt-6";
export var icon = "_kt-7";
export var input = "_kt-8";
export var macroListItem = "_kt-9";
export var mainContent = "_kt-a";
export var microText = "_kt-b";
export var modal = "_kt-w";
export var optionsButton = "_kt-c";
export var paperclip = "_kt-s";
export var pillContent = "_kt-d";
export var preview = "_kt-e";
export var preview2 = "_kt-f";
export var quillEditor = "_kt-q";
export var selectedMacro = "_kt-g";
export var sidebar = "_kt-h";
export var sidebarHeader = "_kt-j";
export var sidebarList = "_kt-i";
export var sidebarListItem = "_kt-k";
export var sidebarSearch = "_kt-l";
export var snoozeDurationWrapper = "_kt-v";
export var statusPillContainer = "_kt-m";
export var tagsContainer = "_kt-n";
export var unselectedMacro = "_kt-o";
export var variable = "_kt-u";
export var wrapper = "_kt-p";